export enum SearchType {
  CLOSED,
  OPEN,
  MAP_AREA,
  MAP_BOUNDS,
}
